import { Pipe, PipeTransform } from '@angular/core';
import { setWhiteSpacesInIban } from '@models/bank-data';
import { removeWhiteSpaces } from '@utils/utils';
@Pipe({
  name: 'hideIban'
})
export class HideIbanPipe implements PipeTransform {
  transform(value: string, hide = true, splitted = true, char = '*'): string {
    value = splitted
      ? setWhiteSpacesInIban(value)
      : removeWhiteSpaces(value);

    if (hide) {
      const hiderChars = splitted
        ? `${char.repeat(4)} `.repeat(5)
        : `${char.repeat(5)}`.repeat(5);

      return `${hiderChars}${value.substr(-4)}`;
    } else {
      return value;
    }
  }
}
